import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { SrCrewsGet, SrCrewService } from '@app/services/sr-crew.service';

@Component({
    selector: 'tt-sr-crews',
    templateUrl: './sr-crews.component.html',
    styleUrls: ['./sr-crews.component.css'],
    standalone: false,
})
export class SrCrewsComponent implements OnInit {
    public page?: SrCrewsGet;
    public crews: Item[] = [];

    constructor(
        private readonly crew: SrCrewService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.crew.getCrews({
            argtype: String(this.navigator?.params['argtype'] ?? ''),
            argvalue: String(this.navigator?.params['argvalue'] ?? ''),
        });
        if (this.page.searchtext !== undefined && this.page.searchtext !== null) {
            this.crews = await this.crew.getCrewList(this.page);
        }
    }
}
